import type {Over} from '@github-ui/drag-and-drop'

import type {DropSide as DropSideType} from '../../../../helpers/dnd-kit/drop-helpers'
import {DropSide} from '../../../../helpers/dnd-kit/drop-helpers'

export const getSashPosition = (over: Over | null, side: DropSideType): number | null => {
  if (!over) return null

  return side === DropSide.BEFORE ? over.rect.top : over.rect.bottom
}

/**
 * Determines if a drop operation should nest the item as the first child under an expanded parent,
 * rather than as a sibling after it.
 *
 * Helper function to further ensure that reorder logic is in sync between the drop handler
 * and the visual drop indicator (sash) when restricting reordering to valid positions
 */
export const isDropAfterExpandedParent = (
  side: DropSideType | null,
  canExpand: boolean,
  isExpanded: boolean,
): boolean => {
  return side === DropSide.AFTER && canExpand && isExpanded
}
